<script>
    export default {
        props: {
            sku: {
                type: String,
                default: null,
            },
            successUrl: {
                type: String,
                default: window.location.href,
            },
            cancelUrl: {
                type: String,
                default: window.location.href,
            }
        },
        data() {
            return {
                key: document.head.querySelector('meta[name="stripe-key"]').content,
                stripe: null,
                processing: false,
                product: this.sku,
            }
        },
        computed: {
            isReady() {
                return this.stripe !== null;
            }
        },
        created() {
            if (!this.key) {
                return;
            }
            this.initiate();
        },
        methods: {
            initiate() {
                if (window.Stripe === 'undefined') {
                    return setTimeout(this.initiate, 500);
                }
                this.stripe = Stripe(this.key);
            },
            changeProduct(event) {
                this.product = event.target.value;
            },
            submit() {
                if (!this.isReady || !this.product) {
                    return;
                }
                this.processing = true;
                this.stripe.redirectToCheckout({
                    items: [
                        {
                            sku: this.product,
                            quantity: 1
                        }
                    ],
                    successUrl: this.successUrl,
                    cancelUrl: this.cancelUrl,
                }).catch(error => {
                    this.processing = false;
                    this.$emit('error', error.message);
                });
            }
        },
        render() {
            return this.$scopedSlots.default({
                isReady: this.isReady,
                changeProduct: this.changeProduct,
                submit: this.submit,
                processing: this.processing,
                selected: this.product,
            });
        }
    }
</script>